import { render, staticRenderFns } from "./CustomCss.vue?vue&type=template&id=b4c48810"
import script from "./CustomCss.vue?vue&type=script&lang=js"
export * from "./CustomCss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports